export default [
  {
    label: 'Impressa',
    value: 'C',
  },
  {
    label: 'Digital',
    value: 'W',
  },
  {
    label: 'Digital + Impressa',
    value: 'A',
  },
];
